module.exports = __webpack_public_path__ + "static/media/csv.c0777cc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/csv.png
// module id = 2548
// module chunks = 0